import { useIdleTimer } from 'react-idle-timer';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../services/apiService';
import { AuthContext } from './authContext';

const IDLE_TIMEOUT = 20 * 60 * 1000; // 20 minutes
const PROMPT_TIMEOUT = 1 * 60 * 1000; // 1 minute

const IdleHandler: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleOnIdle = async () => {
    try {
      await ApiService.post('/auth/logout', {});
    } catch (err) {
      console.error('Error calling logout', err);
    }

    localStorage.removeItem('userId');
    localStorage.removeItem('name');
    localStorage.removeItem('role');
    window.dispatchEvent(new Event('authFailure'));
    navigate('/login', { replace: true });
  };

  const idleTimer = useIdleTimer({
    timeout: IDLE_TIMEOUT,
    promptBeforeIdle: PROMPT_TIMEOUT,
    onIdle: handleOnIdle,
    crossTab: false,
    startManually: true,
  });

  useEffect(() => {
    if (isAuthenticated) {
      idleTimer.reset();   // Clear previous state
      idleTimer.start();   // Start fresh on each mount
    } else {
      idleTimer.pause();   // Stop tracking when logged out
    }
  }, [isAuthenticated, idleTimer]);

  return null;
};

export default IdleHandler;
